<template>
    <account-link :account-no="accountNo" class="text-primary">{{ accountNo }}</account-link>
</template>

<script setup lang="ts">
import {computed, provide} from 'vue'
import AccountLink from '@/bookkeeping-account/AccountLink.vue'

const props = defineProps({
    params: {required: true, type: Object}
})

provide('panelId', props.params.context.panelId)

const BookkeepingAccount = computed(() => {
    return props.params.data
})

const accountNo = computed(() => {
    return BookkeepingAccount.value.accountNo
})


</script>

<style>

</style>